export const ENUM__language_type = {
  /*
   * DEVELOPMENT LANGUAGES
   */
  DEVELOPMENT: 'cimode',
  EMPTY: 'empty',
  PIGDOG: 'ru',

  /*
   * SUPPORTED LANGUAGES
   */
  UKRAINIAN: 'uk',
  ENGLISH: 'en',
};
